import _ from 'lodash';

export const hasValidInput = (input, models) => {
  return !_.some(models, model => {
    if (model.hasError) {
      return model.hasError(_.get(input, model.path));
    } else if (model.group) {
      return !hasValidInput(input, model.group);
    }
    return false;
  });
};

export const filterModelsByPath = (models, paths) => {
  return _.filter(models, ({ path }) => _.some(paths, value => value === path));
};
